import React from 'react';
import { Carousel } from 'antd';
//import CommonVideo from '../common/CommonVideo';
import { IoIosArrowDown } from 'react-icons/io';
import LogoImage from '../../assets/images/landing-logo.svg';
import birthdayBanner from '../../assets/images/landing_page.svg';
import birthdayText from '../../assets/images/birthdayText.svg';
import loginImage from '../../assets/images/login_banner.png';
import parser from 'html-react-parser';

type Props = {
    topHtml: React.ReactNode;
    scrollDown?: () => void;
    restart: boolean;
};

const CarouselPoints = [
    //     `Institutional grade rigorous credit analysis, ongoing monitoring and predictive analytics for
    // risk management.`,
    ` Delivers consistent and high risk-adjusted returns to investors, <br/> zero default rate even during
COVID-19.`,
    ` MAS-licensed Capital Markets Services provided with established track record in Southeast Asia
since 2018.`,
];

const ReferralLandingSignupLeft: React.FC<Props> = ({ scrollDown, topHtml, restart }) => {
    const isShowbirthdayBanner = false;

    return (
        <>
            {isShowbirthdayBanner && (
                <div
                    className={`flex md:hidden justify-center mb-8 bg-white py-1 h-20 ${restart}`}
                    id={'referral_header'}
                >
                    <img src={LogoImage} alt="logo" />
                </div>
            )}
            <div
                id={'referral_container_height'}
                className={`h-full flex flex-col justify-around ${
                    isShowbirthdayBanner ? 'bg-cover bg-no-repeat' : 'bg-cover bg-no-repeat'
                }`}
                style={{
                    minHeight: `${
                        window.innerHeight -
                        (document.getElementById('referral_header')?.offsetHeight
                            ? (document.getElementById('referral_header')?.offsetHeight || 0) + 30
                            : 0)
                    }px`,
                    backgroundImage: isShowbirthdayBanner ? `url(${birthdayBanner})` : `url(${loginImage})`,
                }}
            >
                <div className="h-36" />
                <div>
                    {isShowbirthdayBanner && <div></div>}
                    {isShowbirthdayBanner && (
                        <div className="flex justify-center items-center flex-col">
                            <img src={birthdayText} alt="birthday_text" />
                            <a
                                rel="noreferrer"
                                target="_blank"
                                href={`${process.env.REACT_APP_LANDING_WEB_URL}/5th-anniversary-rebate#t&c`}
                                className="text-gray-300 underline text-xs mt-4 cursor-pointer hover:text-gray-300 hover:underline"
                            >
                                Terms & Conditions apply*
                            </a>
                        </div>
                    )}
                    {!isShowbirthdayBanner && topHtml}
                    {!isShowbirthdayBanner && (
                        <div>
                            {/* <div className="overflow-hidden flex grow flex-col justify-center w-4/5 md:w-7/12 m-auto mt-4 lg:mt-4">
                                <CommonVideo url="https://player.vimeo.com/video/668110549" title="Heli-cap detail" />
                            </div> */}
                            <div className="h-4" />
                            <Carousel
                                effect="fade"
                                dots={true}
                                lazyLoad="progressive"
                                autoplay={true}
                                speed={4000}
                                className="landingLeftCarousel"
                            >
                                {CarouselPoints.map((c, index) => (
                                    <div key={`referral_curosel_${index}`}>
                                        <p
                                            className="w-11/12 md:w-3/4 text-center text-sm m-auto pb-6"
                                            style={{ color: '#F7EEE1', fontFamily: 'WorkSans' }}
                                        >
                                            {parser(c)}
                                        </p>
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    )}
                    <div className="h-5" />
                    <p
                        className="hidden md:block w-full text-center text-sm text-[#B1C1D5] pb-1 pt-4 md:pb-1"
                        style={{ color: '#B1C1D5', fontFamily: 'WorkSans' }}
                    >
                        Ready to sign-up? Leave us your contact{' '}
                        <a
                            className="underline"
                            rel="noreferrer"
                            href="https://www.helicap.com/contact"
                            target={'_blank'}
                        >
                            here
                        </a>{' '}
                        {/* for a quick 5 minute introductory call */}
                    </p>
                    {scrollDown && (
                        <p className="block md:hidden w-full text-center text-base text-white pt-2 pb-2">
                            Sign Up <IoIosArrowDown onClick={() => scrollDown()} className="m-auto" size={'1rem'} />
                        </p>
                    )}
                </div>
            </div>
        </>
    );
};

export default ReferralLandingSignupLeft;
